import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { shopid, getUserId, imagePrefix } from "../../utils/url";
import { getProductByIdController } from "../../../node_modules/shops-query/src/modules/products";
import { fetchProducts } from "../../../node_modules/shops-query/src/modules/products/queries/get";
import { IoMdShare } from "react-icons/io";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import {
  addToWishlistController,
  removeFromWishlistController,
  getWishlistController,
} from "../../../node_modules/shops-query/src/modules/wishlist";
import {
  calculateDiscountPercentage,
  calculateFinalPrice,
} from "../../utils/priceCalculator";
import { fetchSpecificationsByShop } from "../../../node_modules/shops-query/src/modules/Specifications/index.js";
import { addToCart, fetchCart } from "../../../node_modules/shops-query/src/modules/cart/index.js";
import Button from "../button";
import ExpandableSection from "../expandableSection";
import { useToast } from "../toast";
import { useContext } from "react";
import LoginModalContext from "../../contexts/LoginModalContext";
import { addToGuestCart, getGuestCart, clearGuestCart } from "../../utils/handleGuestCart";
import { Title, Meta, Link } from "react-head";
// import RecommendedForYou from "../recommendedForYou";
import TrendingNow from "../recommendedForYou/recommendedcart";
import Loading from "../loading"
import shopController from "../../../node_modules/shops-query/src/modules/shop";
import { fetchAddress } from "../../../node_modules/shops-query/src/modules/address/index.js";
import PaymentComponent from "../paymentComponent";

const ProductDescriptionPage = () => {
  const [productData, setProductData] = useState([]);
  const [userId, setUserId] = useState(null);
  const { showToast } = useToast();
  const { openLogin } = useContext(LoginModalContext);
  const { productId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [, setSelectedOptions] = useState({}); // variant selection updates only
  const [isProductInCart, setIsProductInCart] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [orderAddress, setOrderAddress] = useState(null);
  const [isBuyingNow, setIsBuyingNow] = useState(false); // Fix for loading state overlap
  const [activeImage, setActiveImage] = useState(null);

  const [shopInfo, setShopInfo] = useState(null);
  const [showAllSpecs, setShowAllSpecs] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [isLoadingWishlist, setIsLoadingWishlist] = useState(false);

  useEffect(() => {
    const checkWishlist = async () => {
      if (!userId) return;
      try {
        const wishlistData = await getWishlistController(userId, shopid);
        const exists = wishlistData?.some(
          (p) => Number(p?.productId) === Number(productId)
        );
        setIsWishlisted(exists);
      } catch (error) {
        console.log("Error checking wishlist:", error);
      }
    };
    checkWishlist();
  }, [productId, userId]);

  const handleWishlistToggle = async () => {
    if (!userId) {
      openLogin();
      return;
    }
    setIsLoadingWishlist(true);
    try {
      const pId = Number(productId);
      if (isWishlisted) {
        await removeFromWishlistController({ userId, productId: pId, shopId: shopid });
        setIsWishlisted(false);
        showToast({ message: "Removed from wishlist", type: "success" });
      } else {
        await addToWishlistController(pId, shopid, userId);
        setIsWishlisted(true);
        showToast({ message: "Added to wishlist", type: "success" });
      }
    } catch (error) {
       console.log("Wishlist error", error);
       showToast({ message: "Wishlist action failed", type: "error" });
    } finally {
      setIsLoadingWishlist(false);
    }
  };

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    e.target.style.transformOrigin = `${x}% ${y}%`;
    e.target.style.transform = "scale(2)";
  };

  const handleMouseLeaveImage = (e) => {
    e.target.style.transformOrigin = "center center";
    e.target.style.transform = "scale(1)";
  };

  useEffect(() => {
    const getUserData = async () => {
      try {
        const userData = await getUserId();
        setUserId(userData);
      } catch (error) {
        console.log("Something went wrong while fetching userId", error);
      }
    };
    getUserData();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    const fetchProductDetails = async (productid) => {
      try {
        setLoading(true);
        const productDetails = await fetchProducts({ productId: parseInt(productId), byProductId: true });
        // Initialize selected options with current product's specifications
        const initialOptions = {};

        // First, add current product's specifications
        if (productDetails.Specifications) {
          productDetails.Specifications.forEach((spec) => {
            if (spec.value) {
              initialOptions[spec.specification] = spec.value;
            }
          });
        }

        // Then add specs from variant data (this will override if same spec exists)
        if (productDetails.spec) {
          productDetails.spec.forEach((spec) => {
            if (
              spec.value &&
              spec.value.length > 0 &&
              spec.value[0].products &&
              spec.value[0].products.length > 0
            ) {
              // Only set if not already set from current product specs
              if (!initialOptions[spec.SpecificationMastername]) {
                initialOptions[spec.SpecificationMastername] =
                  spec.value[0].products[0].value;
              }
            }
          });
        }

        setSelectedOptions(initialOptions);
        setProductData(productDetails);
        setActiveImage(productDetails?.featureImage);
      } catch (error) {
        console.log("Something went wrong", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductDetails(productId);
  }, [productId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const productSpecifications = async () => {
      try {
        await fetchSpecificationsByShop(shopid);
      } catch (error) {
        console.log("Specification error", error);
      }
    };
    productSpecifications();
  }, []);

  // Fetch shop info for payment configuration
  useEffect(() => {
    const loadShop = async () => {
      try {
        const info = await shopController.fetchShops({ id: shopid });
        setShopInfo(info?.[0] || info);
      } catch (e) {
        console.log("Failed to load shop info", e);
      }
    };
    loadShop();
  }, []);

  const handleBuyNow = async () => {
    try {
      if (!userId) {
        openLogin();
        return;
      }
      
      setIsBuyingNow(true);
      // Check if already in cart
      const existingCart = await fetchCart(shopid, userId);
      const alreadyInCart = existingCart.some(
        (item) => String(item.productId) === String(productId)
      );

      if (!alreadyInCart) {
        await addToCart({ productId, shopId: shopid, userId });
        showToast({ message: "Added to cart", type: "success" });
        window.dispatchEvent(new Event('cartUpdated'));
      }
      
      navigate("/cart");
    } catch (err) {
      console.log("Buy Now error", err);
      showToast({ message: "Unable to process request", type: "error" });
    } finally {
      setIsBuyingNow(false);
    }
  };

  const handleAddToCart = async () => {
    setIsAddingToCart(true);
    try {
      if (!userId) {
        // Guest user - add to guest cart
        const guestCart = getGuestCart();
        const alreadyInGuestCart = guestCart.some(
          (item) => item.productId === parseInt(productId)
        );

        if (alreadyInGuestCart) {
          navigate("/cart");
          setIsAddingToCart(false);
          return;
        }

        const success = addToGuestCart({
          productId: parseInt(productId),
          quantity: 1,
          name: productData.name,
          price: productData.prize,
          discount: productData.discount,
          tax: productData.tax,
          featureImage: productData.featureImage,
        });

        if (success) {
          showToast({ message: "Added to cart", type: "success" });
          setIsProductInCart(true);
          window.dispatchEvent(new Event('cartUpdated'));
        } else {
          showToast({ message: "Failed to add to cart", type: "error" });
        }
        setIsAddingToCart(false);
        return;
      }

      // Logged in user - check cart
      const existingCart = await fetchCart(shopid, userId);
      const alreadyInCart = existingCart.some(
        (item) => String(item.productId) === String(productId)
      );

      if (alreadyInCart) {
        navigate("/cart");
        setIsAddingToCart(false);
        return;
      }

      // Add to cart if not already present
      await addToCart({ productId, shopId: shopid, userId });
      showToast({ message: "Added to cart", type: "success" });
      setIsProductInCart(true);
      window.dispatchEvent(new Event('cartUpdated'));
    } catch (error) {
      console.log("Error while adding to cart", error);
      showToast({ message: "Failed to add to cart", type: "error" });
    } finally {
      setIsAddingToCart(false);
    }
  };

  // Check if product is in cart on component mount and when productId changes
  useEffect(() => {
    const checkProductInCart = async () => {
      if (!userId) {
        const guestCart = getGuestCart();
        const inCart = guestCart.some(
          (item) => item.productId === parseInt(productId)
        );
        setIsProductInCart(inCart);
        return;
      }

      try {
        const existingCart = await fetchCart(shopid, userId);
        const inCart = existingCart.some(
          (item) => String(item.productId) === String(productId)
        );
        setIsProductInCart(inCart);
      } catch (error) {
        console.log("Error checking cart:", error);
        setIsProductInCart(false);
      }
    };

    checkProductInCart();
  }, [productId, userId]);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return "/placeholder-product.jpg";
    return imgPath.startsWith("http") ? imgPath : `${imagePrefix}${imgPath}`;
  };

  const findVariantProductId = (selectedOptions) => {
    if (!productData || !productData.spec) return null;

    const allVariantProducts = {};

    productData.spec.forEach((spec) => {
      spec.value?.[0]?.products?.forEach((variant) => {
        if (!allVariantProducts[variant.productId]) {
          allVariantProducts[variant.productId] = {};
        }
        allVariantProducts[variant.productId][spec.SpecificationMastername] =
          variant.value;
      });
    });

    // Also include current product in the search
    const currentProductSpecs = {};
    productData.Specifications?.forEach((spec) => {
      if (spec.value) {
        currentProductSpecs[spec.specification] = spec.value;
      }
    });

    // Add current product to the search pool
    if (productData.id) {
      allVariantProducts[productData.id] = currentProductSpecs;
    }

    const matchedVariant = Object.entries(allVariantProducts).find(
      ([variantId, specs]) => {
        return Object.entries(selectedOptions).every(
          ([key, value]) => specs[key] === value
        );
      }
    );

    return matchedVariant ? parseInt(matchedVariant[0]) : null;
  };

  const fetchVariantProductData = async (variantProductId) => {
    try {
      setLoading(true);
      const variantProduct = await getProductByIdController(variantProductId);

      // Initialize selected options for the new variant
      const newInitialOptions = {};
      if (variantProduct.Specifications) {
        variantProduct.Specifications.forEach((spec) => {
          if (spec.value) {
            newInitialOptions[spec.specification] = spec.value;
          }
        });
      }

      setSelectedOptions(newInitialOptions);
      setProductData(variantProduct);
      window.scrollTo(0, 0);
      navigate(`/product/${variantProductId}`);
    } catch (err) {
      showToast({ message: err.message || "Failed to load variant", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleOptionSelect = (specName, value, optionProductId) => {
    // If it's a color selection and we have a productId, navigate directly
    if (
      optionProductId &&
      optionProductId !== productData.id
    ) {
      fetchVariantProductData(optionProductId);
      return;
    }

    // For other specifications or if no productId, use the existing logic
    setSelectedOptions((prev) => {
      const updatedOptions = {
        ...prev,
        [specName]: value,
      };

      const variantProductId = findVariantProductId(updatedOptions);

      if (variantProductId && variantProductId !== productData.id) {
        fetchVariantProductData(variantProductId);
      }

      return updatedOptions;
    });
  };

  // Helper function for color values
  const getColorValue = (colorName) => {
    if (!colorName) return "#ccc";

    const colorMap = {
      red: "#ff0000",
      green: "#008000",
      blue: "#0000ff",
      pink: "#ffc0cb",
      black: "#000000",
      white: "#ffffff",
      yellow: "#ffff00",
      purple: "#800080",
      orange: "#ffa500",
      gray: "#808080",
      brown: "#a52a2a",
      cyan: "#00ffff",
      magenta: "#ff00ff",
      lime: "#00ff00",
      maroon: "#800000",
      navy: "#000080",
      olive: "#808000",
      teal: "#008080",
      silver: "#c0c0c0",
      gold: "#ffd700",
    };

    const lowerColor = colorName.toLowerCase();
    return colorMap[lowerColor] || lowerColor;
  };

  const renderSpecificationOptions = () => {
    if (!productData) return null;

    const currentSpecs = {};
    productData.Specifications?.forEach((spec) => {
      if (spec.value && ["color", "size"].includes(spec.specification?.toLowerCase())) {
        currentSpecs[spec.specification.toLowerCase()] = spec.value;
      }
    });

    const variantSpecs = productData.spec?.filter(
      (spec) =>
        spec.value &&
        spec.value.length > 0 &&
        spec.value[0].products &&
        spec.value[0].products.length > 0 &&
        ["color", "size"].includes(spec.SpecificationMastername?.toLowerCase())
    );

    const renderSpecGroup = (specName, options, isColorSpec, defaultValue) => {
      const sortedOptions = [
        ...options.filter((opt) => opt.value?.toLowerCase() === defaultValue?.toLowerCase()),
        ...options.filter((opt) => opt.value?.toLowerCase() !== defaultValue?.toLowerCase()),
      ];

      return (
        <div key={specName} className="mt-4">
          <h3 className="font-medium text-[18px] text-[#555] mb-3">
            {specName}
          </h3>
          <div className="flex flex-wrap gap-3">
            {sortedOptions.map((option) => {
              const isDefault =
                option.value?.toLowerCase() === defaultValue?.toLowerCase();

              return (
                <button
                  key={`${specName}-${option.value}`}
                  onClick={() => {
                    if (!isDefault) {
                      handleOptionSelect(specName, option.value, option.productId);
                    }
                  }}
                  disabled={isDefault}
                  className={`
                    rounded-md transition-all
                    ${isColorSpec
                      ? `
                          p-2 flex items-center justify-center
                          ${isDefault ? "ring-2 ring-[#F74F25] ring-offset-2" : "border border-gray-300"}
                        `
                      : `
                          px-4 py-2 border border-[#C44174]
                          ${isDefault ? "bg-[#F74F25] text-white" : "text-brandblack bg-brandwhite"}
                        `
                    }
                    ${isDefault ? "cursor-default opacity-90" : "cursor-pointer"}
                  `}
                  style={{ minWidth: isColorSpec ? 48 : "auto" }}
                >
                  {isColorSpec ? (
                    <span
                      className="w-7 h-7 rounded-full inline-block"
                      style={{
                        backgroundColor: getColorValue(option.value),
                      }}
                    />
                  ) : (
                    <span className="text-sm">{option.value}</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      );
    };

    return (
      <>
        {["color", "size"].map((specKey) => {
          const isColorSpec = specKey === "color";
          const variant = variantSpecs?.find(
            (v) => v.SpecificationMastername?.toLowerCase() === specKey
          );

          let defaultValue = currentSpecs[specKey];
          if (!defaultValue && variant) {
            for (const v of variant.value) {
              const match = v.products?.find((p) => p.productId === productData.id);
              if (match) {
                defaultValue = match.value;
                break;
              }
            }
          }

          if (variant) {
            const allOptions = variant.value.flatMap((v) => v.products || []);
            let uniqueOptions = allOptions.reduce((acc, opt) => {
              if (!acc.some((o) => o.value.toLowerCase() === opt.value.toLowerCase())) acc.push(opt);
              return acc;
            }, []);

            if (
              defaultValue &&
              !uniqueOptions.some((opt) => opt.value.toLowerCase() === defaultValue.toLowerCase())
            ) {
              uniqueOptions.unshift({ value: defaultValue, productId: productData.id });
            }

            return renderSpecGroup(
              specKey.charAt(0).toUpperCase() + specKey.slice(1),
              uniqueOptions,
              isColorSpec,
              defaultValue
            );
          } else if (defaultValue) {
            return renderSpecGroup(
              specKey.charAt(0).toUpperCase() + specKey.slice(1),
              [{ value: defaultValue, productId: productData.id }],
              isColorSpec,
              defaultValue
            );
          }

          return null;
        })}
      </>
    );
  };

  // const productImages = productData.productImage?.slice(0, 4) || [];
  const discountValue = Number(productData.discount) || 0;
  const formatPrice = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return value || 0;
    return Math.round(num);
  };

  const handleShare = async () => {
    const url = window.location.href;
    const shareData = {
      title: productData?.name || "Product",
      text: "Check out this product!",
      url,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
          fallbackCopyTextToClipboard(url);
        }
      }
    } else {
      fallbackCopyTextToClipboard(url);
    }
  };

  const fallbackCopyTextToClipboard = async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        showToast({ message: "Link copied to clipboard!", type: "success" });
      } else {
        throw new Error("Clipboard API unavailable");
      }
    } catch (err) {
      console.warn("Clipboard API failed, using fallback", err);
      // Detailed fallback
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Ensure it's not visible but part of DOM
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "0";
        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          showToast({ message: "Link copied to clipboard!", type: "success" });
        } else {
          showToast({ message: "Unable to copy link", type: "error" });
        }
      } catch (fallbackErr) {
        console.error("Fallback copy failed", fallbackErr);
        showToast({ message: "Unable to share link", type: "error" });
      }
    }
  };


  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-white text-[24px] font-semibold">
        <Loading />      </div>
    );
  }

  return (
    <div className="font-poppins">
      <Title>
        {productData?.name
          ? `${productData.name} | Boo Originals`
          : "Boo Originals"}
      </Title>
      <Meta
        name="description"
        content={
          productData?.description
            ? productData.description.replace(/<[^>]+>/g, "").slice(0, 160)
            : "Buy your favorite clothes at Boo."
        }
      />
      <Meta
        name="keywords"
        content={`${productData?.name}, ${productData?.category}, buy online, ONE BIG`}
      />

      <Meta
        property="og:title"
        content={productData?.name || "ONE BIG Product"}
      />
      <Meta
        property="og:Product description"
        content={
          productData?.description
            ? productData.description.replace(/<[^>]+>/g, "").slice(0, 160)
            : "Buy your favorite clothes at BOO."
        }
      />
      <Meta property="og:type" content="product" />
      <Meta property="og:url" content={window.location.href} />
      <Meta
        property="og:image"
        content={getImageUrl(productData?.featureImage)}
      />
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content={productData?.name || "ONE BIG"} />
      <Meta
        name="twitter:description"
        content={
          productData?.description
            ? productData.description.replace(/<[^>]+>/g, "").slice(0, 160)
            : "Buy your favorite clothes at Boo."
        }
      />
      <Meta
        name="twitter:image"
        content={getImageUrl(productData?.featureImage)}
      />
      <Link rel="canonical" href={window.location.href} />

      {/* Main Product Content */}
      <div className="max-w-[1440px] mx-auto px-4 md:px-16 mt-[40px] max-md:mt-[20px]">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left: Images */}
          <div className="flex-1">
            <div className="flex flex-col items-center lg:items-end">
              <div className="w-full relative overflow-hidden group">
                {/* Spacer Image to set height matches active image */}
                <img
                  src={getImageUrl(activeImage || productData.featureImage)}
                  alt=""
                  className="w-full h-auto max-h-[900px] object-contain opacity-0 pointer-events-none"
                />
                
                {/* Stacked Images for Transition */}
                {[...new Set([productData.featureImage, ...(productData.productImage?.map((p) => p.image) || [])])].filter(Boolean).map((imgSrc) => (
                  <div 
                    key={imgSrc} 
                    className={`absolute inset-0 w-full h-full transition-opacity duration-700 ease-in-out ${
                      (activeImage || productData.featureImage) === imgSrc ? 'opacity-100 z-10' : 'opacity-0 z-0'
                    }`}
                  >
                    <img
                      src={getImageUrl(imgSrc)}
                      alt=""
                      className="w-full h-full object-contain transition-transform duration-200 cursor-zoom-in"
                      onMouseMove={handleMouseMove}
                      onMouseLeave={handleMouseLeaveImage}
                    />
                  </div>
                ))}
            
                 {/* Wishlist Icon */}
                <div
                  className="absolute top-4 right-4 bg-white p-2 rounded-full cursor-pointer shadow-md z-20"
                  onClick={handleWishlistToggle}
                >
                  {isWishlisted ? (
                    <FaHeart className="text-[#D54420] text-[24px]" />
                  ) : (
                    <FaRegHeart className="text-[#D54420] text-[24px]" />
                  )}
                </div>
              </div>

              <div className="w-full mt-4 grid grid-cols-2 gap-4">
                {productData.productImage?.map((img, index) => (
                  <img
                    key={index}
                    src={`${imagePrefix}${img.image}`}
                    alt={`Product ${index + 1}`}
                    className={`w-full h-auto object-contain cursor-pointer border-2 transition-all ${
                      activeImage === img.image
                        ? 'border-[#D54420] opacity-100'
                        : 'border-transparent opacity-70 hover:opacity-100'
                    }`}
                    onClick={() => setActiveImage(img.image)}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Right: Details */}
          <div className="flex-1 flex flex-col lg:sticky lg:top-[20px] h-fit">
            {/* Breadcrumb and Share */}
            <div className="path-and-share flex justify-between items-center">
              <p className="text-[16px] max-md:text-[14px]">
                <span
                  onClick={() => navigate("/")}
                  className="text-neutral-halfwhite cursor-pointer"
                >
                  Home
                </span>{" "}
                &gt; <span className="capitalize">{productData.name}</span>
              </p>
              <IoMdShare
                onClick={handleShare}
                className="h-[24px] w-[24px] max-md:h-[20px] max-md:w-[20px] text-[#C4C4C4] hover:text-[#999999]"
              />
            </div>

            {/* Product Name & Price */}
            <div className="product-name mt-[24px]">
              <p className="font-semibold text-[24px] leading-[100%] uppercase max-md:text-[20px]">
                {productData.name}
              </p>
              <div className="pricing-div flex flex-wrap mt-[16px] items-center">
                {discountValue > 0 ? (
                  <>
                    <p className="font-semibold text-[24px] leading-[100%] max-md:text-[20px]">
                      ₹
                      {formatPrice(
                        calculateFinalPrice(
                          productData.prize,
                          productData.discount
                        )
                      )}
                    </p>
                    <p className="ml-[16px] font-normal text-[24px] leading-[100%] line-through text-neutral-halfwhite max-md:text-[18px]">
                      ₹{formatPrice(productData.prize)}
                    </p>
                    <p className="ml-[16px] font-semibold text-[24px] text-primary-default uppercase max-md:text-[18px]">
                      {calculateDiscountPercentage(
                        productData.prize,
                        productData.discount
                      )}
                      % off
                    </p>
                  </>
                ) : (
                  <p className="font-semibold text-[24px] leading-[100%] max-md:text-[20px]">
                    ₹{formatPrice(productData.prize)}
                  </p>
                )}
              </div>
              <p className="font-normal text-[12px] text-neutral-grey-2 mt-[10px]">
                (Inclusive of all taxes)
              </p>
            </div>

            <hr className="h-px bg-gray-300 border-0 mt-[16px] w-full" />

            {/* Specification Options (Color & Size Variants) */}
            <div className="specification-options mt-4">
              {renderSpecificationOptions()}
            </div>

            {/* Buttons */}
            <div className="btns mt-[56px] max-md:mt-[32px]">
              <div className="flex gap-[16px] max-md:flex-col">
                <Button
                  text={isProductInCart ? "Go To Cart" : "Add To Cart"}
                  variant="secondary"
                  onClick={handleAddToCart}
                  loading={isAddingToCart}
                />
                <Button
                  text="Buy Now"
                  variant="primary"
                  onClick={handleBuyNow}
                  loading={isBuyingNow}
                />
              </div>
            </div>

            {showPayment && (
              <div className="mt-6">
                <PaymentComponent
                  cartAmount={(() => {
                    const price = Number(productData?.prize) || 0;
                    const discount = Number(productData?.discount) || 0;
                    return Math.max(0, Math.round(price - discount));
                  })()}
                  orderAddress={orderAddress}
                  shopId={shopid}
                  userId={userId}
                  shopPhone={shopInfo?.phone}
                  cartItems={[
                    {
                      productId: productData?.id,
                      name: productData?.name,
                      prize: productData?.prize,
                      Discount: productData?.discount,
                      quantity: 1,
                      featureImage: productData?.featureImage,
                    },
                  ]}
                  siteConfig={{
                    razorpayKey: shopInfo?.siteConfigurations?.razorpayKey,
                    razorpaySecretKey: shopInfo?.siteConfigurations?.razorpaySecretKey,
                    name: shopInfo?.name,
                  }}
                  showToast={showToast}
                  onOrderSuccess={(msg) => {
                    showToast({ message: msg });
                    if (!userId) {
                      clearGuestCart();
                    }
                    window.dispatchEvent(new Event("cartUpdated"));
                    setShowPayment(false);
                    setTimeout(() => navigate("/"), 1500);
                  }}
                  onOrderFailure={(err) => {
                    showToast({
                      message:
                        typeof err === "string" ? err : err?.message || "Failed to place order",
                      type: "error",
                    });
                  }}
                  onClose={() => setShowPayment(false)}
                />
              </div>
            )}

            {/* Specifications */}
            <div className="specifications mt-[32px] w-full pb-5 border border-[#0000001A] max-md:h-auto">
              <p className="mt-[20px] ml-[20px] font-semibold text-[18px] text-neutral-black max-md:ml-[16px]">
                Specifications
              </p>

              {/* Specifications Grid */}
              {productData.Specifications && productData.Specifications.length > 0 && (
                <>
                  <div className="grid grid-cols-3 gap-x-8 gap-y-6 mt-[24px] ml-[20px] mr-[20px] max-md:ml-[16px] max-md:mr-[16px] max-md:grid-cols-3 max-md:gap-x-4">
                    {(showAllSpecs
                      ? productData.Specifications
                      : productData.Specifications.slice(0, 6)
                    ).map((spec, index) => (
                      <div key={index} className="flex flex-col">
                        <p className="font-normal md:text-[16px] text-[14px] text-gray-600 capitalize mb-1">
                          {spec.specification}
                        </p>
                        <p className="font-semibold md:text-[20px] text-[16px] capitalize text-neutral-black">
                          {spec.value || "N/A"}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* SEE MORE Button */}
                  {productData.Specifications.length > 6 && (
                    <button
                      onClick={() => setShowAllSpecs(!showAllSpecs)}
                      className="ml-[20px] mt-[16px] text-primary-default font-semibold text-[14px] uppercase max-md:ml-[16px]"
                    >
                      {showAllSpecs ? "SEE LESS" : "SEE MORE"}
                    </button>
                  )}
                </>
              )}
            </div>

            {/* Expandable Sections (Description & Details) */}
            <ExpandableSection
              title="Description"
              defaultOpen={false}
              content={
                <div
                  dangerouslySetInnerHTML={{ __html: productData.description }}
                ></div>
              }
            />
            <ExpandableSection
              title="Product Details"
              defaultOpen={false}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      productData.specification ||
                      "No additional product details available.",
                  }}
                />
              }
            />
          </div>
        </div>

        {/* Trending Now Section - Placed under the details section */}
        <div className="mt-8 md:mt-0">
          <TrendingNow showCategories={false} excludeIds={[productId]} />
        </div>
      </div>
    </div>
  );
};

export default ProductDescriptionPage;
